module.exports = __webpack_public_path__ + "static/img/zzjzv.2f55dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/zzjzv.png
// module id = L8jd
// module chunks = 0